const devicePaths = {
  SEARCH_DEVICE: "search",
  DEVICE_ID: (id) => id,
};

export default devicePaths;
